/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import Typography from '@material-ui/core/Typography';
import I18n from '../../../components/Translate/I18n';
import SimCardInterface from '../../../interfaces/platform/SimCardInterface';
import OperationSynchronizeInterface from '../../../interfaces/platform/OperationSynchronizeInterface';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { configDefault } from '../../../core/config';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { simCardConstants } from '../../../modules/simcard/actions';
import { OperatorMvneTypeMap } from '../../../modules/lib/hooks/useOperatorType';

interface SimCardSynchronizeProps {
    classes: any;
    dispatch: any;
    simCard: SimCardInterface;
}

interface SimCardSynchronizeState {
    operationSynchronize: OperationSynchronizeInterface | null;
}

class SimCardSynchronize extends PureComponent<SimCardSynchronizeProps, SimCardSynchronizeState> {
    private itemLoader: ItemLoaders;

    constructor(props: SimCardSynchronizeProps, context: SimCardSynchronizeState) {
        super(props, context);

        this.state = {
            operationSynchronize: null,
        };
        this.itemLoader = new ItemLoaders(this.props.dispatch);
    }

    componentDidMount(): void {
        const { simCard } = this.props;
        this.itemLoad(simCard.msisdn);
    }

    itemLoad = (msisdn: string): void => {
        this.itemLoader.getWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/operation_synchronizes/' + msisdn, configDefault.PLATFORM_API_PREFIX)),
            simCardConstants.D_SIM_CARD_GET_SYNCHRONIZE,
            (data: OperationSynchronizeInterface): void => {
                this.setState({
                    operationSynchronize: data,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { operationSynchronize } = this.state;
        const { simCard } = this.props;

        return (
            <GridContainer>
                {simCard.operatorType !== OperatorMvneTypeMap.OPL && (
                    <React.Fragment>
                        <GridItem xs={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                <I18n trans="simcard:list.last_full_synchronize_start" />
                            </Typography>
                        </GridItem>
                        <GridItem xs={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                {operationSynchronize?.fullSynchronizeLastStartTime &&
                                    DateHelperTs.format(operationSynchronize.fullSynchronizeLastStartTime)}
                            </Typography>
                        </GridItem>
                        <GridItem xs={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                <I18n trans="simcard:list.last_full_synchronize_stop" />
                            </Typography>
                        </GridItem>
                        <GridItem xs={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                {operationSynchronize?.fullSynchronizeLastFinishTime &&
                                    DateHelperTs.format(operationSynchronize.fullSynchronizeLastFinishTime)}
                                {operationSynchronize?.synchronizeInProgress && !operationSynchronize.fullSynchronizeLastFinishTime && (
                                    <I18n trans="simcard:list.synchronize_in_progress" />
                                )}
                            </Typography>
                        </GridItem>
                    </React.Fragment>
                )}
                <GridItem xs={6}>
                    <Typography variant="subtitle2" gutterBottom>
                        <I18n trans="simcard:list.last_short_synchronize_start" />
                    </Typography>
                </GridItem>
                <GridItem xs={6}>
                    <Typography variant="subtitle2" gutterBottom>
                        {operationSynchronize?.shortSynchronizeLastStartTime &&
                            DateHelperTs.format(operationSynchronize.shortSynchronizeLastStartTime)}
                    </Typography>
                </GridItem>
                <GridItem xs={6}>
                    <Typography variant="subtitle2" gutterBottom>
                        <I18n trans="simcard:list.last_short_synchronize_stop" />
                    </Typography>
                </GridItem>
                <GridItem xs={6}>
                    <Typography variant="subtitle2" gutterBottom>
                        {operationSynchronize?.shortSynchronizeLastFinishTime &&
                            DateHelperTs.format(operationSynchronize.shortSynchronizeLastFinishTime)}
                        {operationSynchronize?.synchronizeInProgress && !operationSynchronize.shortSynchronizeLastFinishTime && (
                            <I18n trans="simcard:list.synchronize_in_progress" />
                        )}
                    </Typography>
                </GridItem>
                {operationSynchronize?.fullSynchronizeError && (
                    <GridItem xs={12}>
                        <Typography variant="subtitle2" gutterBottom>
                            <I18n trans="simcard:list.synchronize_error_state" />
                        </Typography>
                    </GridItem>
                )}
            </GridContainer>
        );
    }
}

const mapStateToProps = (state: any): object => {
    return {};
};

export default compose<any, any>(connect(mapStateToProps), withStyles(adescomStyle))(SimCardSynchronize);
